import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface ImagePreviewDialogProps {
  previewImage: string;
  onClose: () => void;
}

export const ImagePreviewDialog = ({ previewImage, onClose }: ImagePreviewDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={Boolean(previewImage)}
      onClose={onClose}
      maxWidth="xl"
      PaperProps={{
        sx: {
          borderRadius: 1,
          boxShadow: (theme) => `0px 8px 24px ${theme.shadows[3]}`,
          overflow: 'hidden',
        },
      }}
      sx={{
        backdropFilter: 'blur(8px)',
        backgroundColor: (theme) => `${theme.palette.common.black}3`,
      }}
    >
      <DialogTitle
        component="div"
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}
      >
        <Typography variant="subtitle1">{t('cases.view.content.imagePreview')}</Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          border: 'none',
        }}
      >
        <Box
          component="img"
          src={previewImage}
          sx={{
            width: '100%',
            objectFit: 'cover',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
